'use client'

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string }
    reset: () => void
}) {
    return (
        <html>
            <body className="bg-black text-white p-8">
                <h2 className="text-red-500 text-3xl font-bold mb-4">CRITICAL GLOBAL ERROR</h2>
                <div className="border border-white/20 p-4 rounded bg-gray-900 overflow-auto max-w-2xl">
                    <p className="font-mono">{error.message}</p>
                    {error.digest && <p className="text-xs text-gray-500 mt-2">Digest: {error.digest}</p>}
                </div>
                <button className="mt-4 px-4 py-2 bg-white text-black rounded" onClick={() => reset()}>
                    Réessayer
                </button>
            </body>
        </html>
    )
}
